import type { AnybillResult } from "~/additionalModels/AnybillResponse";
import type CurrentPricingOverviewDto from "~/models/CurrentPricingOverviewDto";
import type StandardPricingPackageDto from "~/models/StandardPricingPackageDto";
import EndpointPaths from "~/config/constants/EndpointPaths";
import BaseService from "~/services/BaseService";

export class PricingProvider {
  private static _instance: PricingProvider;

  static get instance(): PricingProvider {
    if (PricingProvider._instance === undefined)
      PricingProvider._instance = new PricingProvider();

    return PricingProvider._instance;
  }

  public async getCurrentPricing(): Promise<AnybillResult<CurrentPricingOverviewDto[]>> {
    return BaseService.Instance.get<CurrentPricingOverviewDto[]>(
      {
        path: `${EndpointPaths.PRICING_REFERENCE}`,
      },
    );
  }

  public async getPricingById(pricingId: string): Promise<AnybillResult<StandardPricingPackageDto>> {
    return BaseService.Instance.get<StandardPricingPackageDto>(
      {
        path: `${EndpointPaths.PRICING_PATH}/${pricingId}`,
      },
    );
  }

  public async getCustomPricings(): Promise<AnybillResult<StandardPricingPackageDto[]>> {
    return BaseService.Instance.get<StandardPricingPackageDto[]>(
      {
        path: `${EndpointPaths.PRICING_CUSTOM_PATH}`,
      },
    );
  }
}
